import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const HomePage = () => {
  const services = [
    {
      title: 'Business Insurance',
      description:
        'Our agency designs insurance programs individually for each client in Bucks County, Montgomery County, and throughout Pennsylvania. This process begins with a survey and analysis of your business operations. We then develop a risk management specification tailored to your needs and submit it to the most competitive construction insurance markets.',
      icon: 'ri-shield-check-line',
    },
    {
      title: 'Over 100 Markets',
      description:
        'We have access to over 100 insurers who specialize in contracting exposures across Pennsylvania. We market your account with the goal of obtaining the most comprehensive coverage and competitive pricing for Bucks County and Montgomery County contractors.',
      icon: 'ri-building-line',
    },
    {
      title: 'Surety Bonding',
      description:
        'Our Surety Bonds department is uniquely qualified to prepare strategies to maximize your surety credit. Our creative underwriting approach has assisted Pennsylvania contractors in reaching their corporate goals for growth.',
      icon: 'ri-file-shield-line',
    },
    {
      title: 'Union Bonds',
      description:
        'Our Union Bonds Program will walk you through every step of the way. It is designed to be as quick and painless as possible. We work with the sureties to get Bucks County and Montgomery County contractors bonded as soon as possible.',
      icon: 'ri-team-line',
    },
  ];

  return (
    <div className="min-h-screen bg-slate-900">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://img1.wsimg.com/isteam/ip/070063be-f79c-42bb-81ec-2fa80d6eea6d/stoll%20agency.jpg"
            alt="Pennsylvania construction project bonded and insured by The Stoll Agency, serving Bucks County and Montgomery County contractors"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/75"></div>
          <div className="absolute inset-0 bg-slate-900/30"></div>
        </div>

        <div className="relative z-10 text-center px-4 max-w-5xl mx-auto w-full">
          <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-4">
            Bucks County &amp; Montgomery County, Pennsylvania
          </p>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            Your Insurance and Surety Bond Professionals
          </h1>
          <p className="text-xl md:text-2xl text-white/85 mb-10 font-light">
            Serving Pennsylvania contractors since 1957 — <strong className="text-green-500">Get the coverage you need!</strong>
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-4 bg-green-600 text-white rounded-full font-semibold text-base hover:bg-green-500 transition-all shadow-lg whitespace-nowrap"
            >
              Contact us for a quote today!
            </Link>
            <a
              href="https://payments.myappliedproducts.com/flow/hpp"
              target="_blank"
              rel="noopener noreferrer"
              className="px-8 py-4 bg-white/10 border border-white/30 text-white rounded-full font-semibold text-base hover:bg-white/20 transition-all shadow-lg whitespace-nowrap backdrop-blur-sm"
            >
              Online Payment Portal
            </a>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/50 animate-bounce">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </section>

      {/* Construction Focused Section */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-3">What We Do</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Construction Focused Insurance &amp; Bonding
            </h2>
            <p className="text-slate-400 max-w-2xl mx-auto">Specialized solutions for contractors in Bucks County, Montgomery County, and across Pennsylvania</p>
            <div className="w-24 h-1 bg-green-600 mx-auto mt-6"></div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div
                key={index}
                className="bg-slate-800 border border-slate-700 rounded-2xl p-8 hover:border-green-500/50 hover:shadow-xl hover:shadow-green-900/20 transition-all duration-300 hover:-translate-y-1"
              >
                <div className="w-16 h-16 bg-green-500/10 border border-green-500/20 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${service.icon} text-3xl text-green-500`}></i>
                </div>
                <h3 className="text-2xl font-bold text-white mb-4">{service.title}</h3>
                <p className="text-slate-400 leading-relaxed">{service.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* In Business Since 1957 */}
      <section className="py-20 bg-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-4xl mx-auto">
            <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-3">Our Legacy</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              In Business Since 1957
            </h2>
            <p className="text-lg text-slate-300 leading-relaxed">
              The Stoll Agency, Inc. is a 4th generation family business that has cultivated close
              relationships with our customers throughout <strong className="text-white">Bucks County</strong>, <strong className="text-white">Montgomery County</strong>, and all of Pennsylvania. We have protected some of our clients for over 50
              years. Our responsiveness is unmatched, and our turnaround time is fast.
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
            {[
              { value: '1957', label: 'Established' },
              { value: '4th', label: 'Generation' },
              { value: '100+', label: 'Markets' },
              { value: '50+', label: 'Yrs Service' },
            ].map((stat, i) => (
              <div key={i} className="bg-slate-900 border border-slate-700 rounded-2xl p-8 text-center">
                <div className="text-4xl font-bold text-green-500 mb-2">{stat.value}</div>
                <div className="text-slate-400 font-medium text-sm">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Decades of Experience */}
      <section className="py-20 bg-slate-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <p className="text-green-500 text-sm font-semibold tracking-widest uppercase mb-3">Leadership</p>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
              Decades of Experience
            </h2>
            <div className="w-24 h-1 bg-green-600 mx-auto"></div>
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl">
              <div className="grid grid-cols-1 lg:grid-cols-2">
                <div className="h-96 lg:h-auto">
                  <img
                    src="https://img1.wsimg.com/isteam/ip/070063be-f79c-42bb-81ec-2fa80d6eea6d/_DSC3814_%20Pete%20web%20(3)-0001.jpg/:/cr=t:3.13%25,l:0%25,w:100%25,h:80%25/rs=w:1240,h:1240,cg:true"
                    alt="Peter N. Stoll Jr., President of The Stoll Agency, construction insurance and surety bond expert serving Bucks County and Montgomery County PA"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-8 lg:p-10 flex flex-col justify-center">
                  <h3 className="text-2xl font-bold text-white mb-1">
                    Peter N. Stoll, Jr., CPCU, AFSB
                  </h3>
                  <p className="text-green-500 font-semibold mb-6">President</p>
                  <div className="space-y-3 text-slate-300 text-sm leading-relaxed">
                    <p><strong className="text-white">35+ Years Experience</strong> Insuring and Bonding Contractors in Pennsylvania</p>
                    <p>Pennsylvania State University B.S. in Insurance — William Elliot Insurance Scholarship recipient</p>
                    <p><strong className="text-white">CPCU</strong> — Chartered Property and Casualty Underwriter</p>
                    <p><strong className="text-white">AFSB</strong> — Associates in Fidelity and Surety Bonding</p>
                    <p><strong className="text-white">CRIS</strong> — Construction Risk Insurance Specialist</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Service Area Banner */}
      <section className="py-14 bg-slate-800 border-y border-slate-700">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h4 id="service-areas" className="text-2xl font-bold text-white mb-4">
            <a href="#service-areas">Proudly Serving Contractors Across Pennsylvania</a>
          </h4>
          <p className="text-slate-400 max-w-3xl mx-auto">
            From <strong className="text-green-500">Bucks County</strong> and <strong className="text-green-500">Montgomery County</strong> to Philadelphia, Chester County, Delaware County, and beyond — The Stoll Agency provides construction insurance and surety bonding throughout the Commonwealth of Pennsylvania.
          </p>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-green-700 to-green-900">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-white/80 mb-10">
            Contact us today for a personalized construction insurance and surety bonding solution in Bucks County, Montgomery County, or anywhere in Pennsylvania.
          </p>
          <Link
            to="/contact"
            className="inline-block px-10 py-4 bg-white text-green-700 rounded-full font-semibold text-lg hover:bg-gray-100 transition-all shadow-lg whitespace-nowrap"
          >
            Get Your Quote
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default HomePage;
